function asList(value) {
  if (Array.isArray(value)) return value.map(item => String(item))
  if (value === null || value === undefined || value === '') return []
  return [String(value)]
}

export function fieldMessages(fieldErrors, name) {
  if (!fieldErrors || !name) return []
  return Object.keys(fieldErrors).reduce((list, key) => {
    const hit = key === name || key.startsWith(`${name}.`) || key.startsWith(`${name}[`)
    if (!hit) return list
    return list.concat(asList(fieldErrors[key]))
  }, [])
}

async function readMaybeBlob(data) {
  if (!(data instanceof Blob)) return data
  try {
    const text = await data.text()
    return JSON.parse(text)
  } catch (error) {
    return null
  }
}

export async function parseInquiryError(error) {
  const status = error?.response?.status || 0
  const data = await readMaybeBlob(error?.response?.data)
  const message = (data && typeof data.message === 'string' && data.message)
    || (typeof error?.message === 'string' ? error.message : '')
  const errors = data?.errors
  if (Array.isArray(errors?.failed)) {
    return {
      status, kind: 'failed', message, failed: errors.failed, fieldErrors: {},
    }
  }
  if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
    const fieldErrors = {}
    Object.keys(errors).forEach(key => {
      if (key === 'failed') return
      const list = asList(errors[key])
      if (list.length) fieldErrors[key] = list
    })
    if (Object.keys(fieldErrors).length) {
      return {
        status, kind: 'fields', message, failed: [], fieldErrors,
      }
    }
  }
  return {
    status, kind: 'message', message, failed: [], fieldErrors: {}, raw: data,
  }
}

export function isGpsForbidden(parsed) {
  const raw = parsed?.raw || {}
  if (raw.location && raw.location.enabled === false) return true
  const text = `${parsed?.message || ''} ${JSON.stringify(raw)}`
  return /X-Latitude|X-Longitude|location\.enabled|gps/i.test(text)
}
